import React, {Component} from 'react';
import {SubCriterionParameter} from "../../domain/criterion/subCriterionParameterDomain";
import {Checkbox, FlatButton} from "material-ui";
import {SubCriterion} from "../../domain/criterion/subCriterionDomain";
import {observer} from "mobx-react";
import sbToolParamsService from "../../service/paramsService";
import {ProjectVersionParamValue} from "../../domain/project/projectVersionParameterValueDomain";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {action} from "mobx";
import {SubCriterionParameterValue} from "../../domain/criterion/subCriterionParameterValueDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";


interface Props {
  subCriterion: SubCriterion
  handleChangeValueState: (bool:boolean)=>void

}


@observer
class ParametersMultiSelectForm extends Component<Props, undefined> {


  @action
  private onSelect = (checked: boolean, valueId: number, subCriterionParam: SubCriterionParameter) => {
    let paramValue = subCriterionParam.parameters.find(p => p.valueId === valueId);

    let toDisableIds : string[] = [];
    if (!checked) {
      subCriterionParam.parameters.forEach(param => {
        if (param.dependsOn.find(depend => depend.value == valueId)) {
          toDisableIds.push(String(param.valueId))
        }
      })
    }

    let versionParam = sbToolParamsService.paramsValues.find(p => p.value === String(paramValue.valueId) && p.parameter.paramId === subCriterionParam.paramId);
    if (versionParam) {
      let newValues = sbToolParamsService.paramsValues.filter(e => e.value !== versionParam.value && !toDisableIds.includes(e.value));
      sbToolParamsService.paramsValues.replace(newValues);
      sbToolParamsService.recalculateParamsNumbers();
    } else {
      let param = new ProjectVersionParamValue({
        value: String(paramValue.valueId),
        projectVersion: SbToolProjectVersionService.projectVersion,
        parameter: subCriterionParam,
        paramNumber: sbToolParamsService.getNextParamNumber(this.props.subCriterion),
        count: 1,
        $new: true
      });
      param.initAfterRead(true);
      sbToolParamsService.paramsValues.push(param);
    }
    this.props.handleChangeValueState(true)

  };

  @action
  private onChangeCount = (value: SubCriterionParameterValue, subCriterionParam: SubCriterionParameter, valueCount: number): void => {
    let versionParam = sbToolParamsService.paramsValues.find(p => p.value === String(value.valueId) && p.parameter.paramId === subCriterionParam.paramId);
    let newCount = versionParam.count + valueCount;
    if (newCount >= 1 && newCount <= value.countLimit) {
      versionParam.count = newCount;
    }
  };

  private isChecked = (valueId : number): boolean => {
    const param: ProjectVersionParamValue = sbToolParamsService.paramsValues.find(p => p.value === String(valueId));
    return param !== undefined //&& value.selected === true;
  };

  private isDisabled = (value: SubCriterionParameterValue): boolean => {
    if (value.dependsOn.length == 0) {
      return false;
    }
    return value.dependsOn.find(elem => !this.isChecked(Number(elem.value))) != undefined
  };


  private renderCheckboxes = (subCriterionParam: SubCriterionParameter) => {

    let sorted = subCriterionParam.parameters.sort((a, b) => {
      return a.valueId - b.valueId;
    });

    return sorted.map(param => {
      return (
        <div key={param.valueId}>
          <Checkbox name={subCriterionParam.name}
                    checked={this.isChecked(param.valueId)}
                    onCheck={(e, checked) => this.onSelect(checked, param.valueId, subCriterionParam)}
                    key={param.valueId}
                    value={param.valueId}
                    disabled={this.isDisabled(param)}
                    label={param.label + " (" + param.value + ")"}/>{this.renderStepper(param, subCriterionParam)}
        </div>)
    })
  };

  private renderStepper = (value: SubCriterionParameterValue, subCriterionParam: SubCriterionParameter) => {
    const isDisabled = !this.isChecked(value.valueId);
    let versionParam = sbToolParamsService.paramsValues.find(p => p.value === String(value.valueId) && p.parameter.paramId === subCriterionParam.paramId);
    if (!value.countLimit || value.countLimit <= 1) {
      return <noscript/>
    }
    if (isDisabled) {
      return <noscript/>
    }
    return (<div style={{display: "inline-block"}}>
      <FlatButton onClick={event => this.onChangeCount(value, subCriterionParam, -1)}>
        <i className="fa fa-minus" aria-hidden="true"/>
      </FlatButton>

      <FlatButton>{versionParam.count}</FlatButton>

      <FlatButton onClick={event => this.onChangeCount(value, subCriterionParam, 1)}>
        <i className="fa fa-plus" aria-hidden="true"/>
      </FlatButton>
    </div>)
  };

  private renderCheckboxGroups(subCriterionParams: SubCriterionParameter[]) {
    return subCriterionParams.map(param => {
      return (<div key={param.paramId}>
        {param.name}
        {this.renderCheckboxes(param)}
      </div>)
    })
  }

  render() {
    return (
      <div style={{marginTop: 20, width: "100%"}}>
        {this.renderCheckboxGroups(this.props.subCriterion.parameters)}
      </div>
    )
  }
}

export default ParametersMultiSelectForm;






// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/parametersMultiSelectForm.tsx